import environment from '../../../common/environment';
import { InstructorSampleAnalytics } from '../instructor-sample.analytics';
import { SampleOrderProductInfo } from '../instructor-sample.interface';
import { StoreState } from '../../../store/store.interface';
import { formattedAuthors } from '../../../common/utils/util';
import { removeAllItemsFromMagentoCart } from '../../cart/shop-cart/thunks/remove-from-cart.thunk';

/**
 * Get formatted authors for an instructor sampling product.
 *
 * @param product
 */
export function getSampleProductAuthors(product: SampleOrderProductInfo): string {
  return formattedAuthors(product.contributors?.join(', ') || '', ', ', ', ', ', ');
}

/**
 * Redirects to Higher Ed home page.
 */
export function redirectToHigherEd(): void {
  window.location.href = environment().mheducationUrl.concat('/highered').concat('.html');
}

/**
 * Redirects to the home page to continue browsing for samples.
 *
 * @param element
 */
function redirectToHome(element?: HTMLElement): void {
  InstructorSampleAnalytics.emitElement('continue-browsing-to-sample', element);
  window.location.href = environment().mheducationUrl;
}

/**
 * Deletes the cart product and redirects the user to the product page if a product URL is provided.
 * Otherwise, it redirects the user to the home page.
 * The product URL is provided from the sample checkout form only.
 * When called from other places, there is no product in the cart to be removed.
 *
 * @param state
 * @param element
 * @param productUrl
 */
export async function redirectToProductOrHome(
  state: StoreState,
  element?: HTMLElement,
  productUrl?: string
): Promise<void> {
  if (productUrl) {
    InstructorSampleAnalytics.emitElement('remove-from-cart-back-to-product', element);
    try {
      await removeAllItemsFromMagentoCart(state);
      window.location.href = productUrl;
    } catch (error) {
      console.error('Failed to clear instructor sample cart', error);
    }
  } else {
    redirectToHome(element);
  }
}
